// Small helper for gentle body-anchoring haptic taps on mobile.
// Falls back silently on devices without navigator.vibrate (e.g., iOS Safari).

export const HAPTICS_SUPPORTED =
  typeof navigator !== "undefined" && typeof navigator.vibrate === "function";

export const HAPTICS_STORAGE_KEY = "stillwater.haptics";
export const HAPTICS_HINT_STORAGE_KEY = "stillwater.hapticsHintSeen";

// Shared very-gentle patterns (ms). Keep short, keep soft.
export const HAPTIC_PATTERNS = {
  // breathing
  inhale: [35],
  hold: [20, 60, 20],
  exhale: [80],
  cycle: [20, 60, 20, 60, 20],
  finish: [30, 80, 30, 80, 60],
  // grounding
  step: [30], // each 5→4→3→2→1 advance
  arrive: [25, 60, 25, 60, 40], // final "you are here"
};

export const vibrate = (pattern) => {
  if (!HAPTICS_SUPPORTED) return;
  try {
    navigator.vibrate(pattern);
  } catch (_) {
    /* silent */
  }
};

export const loadHapticsPreference = () => {
  try {
    const raw = localStorage.getItem(HAPTICS_STORAGE_KEY);
    // Default ON when supported.
    if (raw === null) return HAPTICS_SUPPORTED;
    return raw === "true";
  } catch (_) {
    return HAPTICS_SUPPORTED;
  }
};

export const saveHapticsPreference = (on) => {
  try {
    localStorage.setItem(HAPTICS_STORAGE_KEY, String(on));
  } catch (_) {
    /* silent */
  }
};

// Returns true if we should show the "haptics is on" hint this time.
// Only fires once ever, and only when haptics is actually enabled + supported +
// on a touch-capable / small-screen device (so desktop users aren't shown a
// hint for something they can't feel).
export const shouldShowHapticsHint = () => {
  if (!HAPTICS_SUPPORTED) return false;
  if (!loadHapticsPreference()) return false;
  try {
    if (localStorage.getItem(HAPTICS_HINT_STORAGE_KEY) === "true") return false;
  } catch (_) {
    return false;
  }
  const isTouch =
    typeof window !== "undefined" &&
    (("ontouchstart" in window) ||
      (navigator.maxTouchPoints && navigator.maxTouchPoints > 0));
  const isSmall =
    typeof window !== "undefined" && window.innerWidth <= 820;
  return Boolean(isTouch || isSmall);
};

export const markHapticsHintSeen = () => {
  try {
    localStorage.setItem(HAPTICS_HINT_STORAGE_KEY, "true");
  } catch (_) {
    /* silent */
  }
};
